import React from 'react'
import Login, { Agreement, PrivacyPolicy } from '@/views/micro/login'
import Exception404 from '@/views/built-in/404'
import MainLayout from '@/layout/main'
import {
  DictionaryAudit,
  DictionaryEdit,
  DictionaryView,
} from '@/views/dictionary'
import DictionaryQuote from '@/views/dictionary/quote'
import ExportRecord from '@/views/exportRecord'
import UserManage from '@/views/micro/user'
import RoleManage from '@/views/micro/role'
import Index from '@/views/index'
import Standard from '@/views/standard';
import Knowledge, { KnowledgeAudit, KnowledgeView } from '@/views/dictionary/knowledge'
const privateRoutes = () => [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <Index />,
      },
      {
        path: '/dict-view',
        element: <DictionaryView />,
        auth: true,
        key: 'DICT_BROWSE',
      },
      {
        path: '/dict-edit',
        element: <DictionaryEdit />,
        auth: true,
        key: 'DICT_EDIT',
      },
      {
        path: '/dict-audit',
        element: <DictionaryAudit />,
        auth: true,
        key: 'DICT_AUDIT',
      },
      {
        path: '/export',
        element: <ExportRecord />,
        auth: true,
        key: 'EXPOET_RECORD',
      },
      {
        path: '/user',
        element: <UserManage />,
        auth: true,
        key: 'USER_MANAGER',
      },
      {
        path: '/role',
        element: <RoleManage />,
        auth: true,
        key: 'USER_ROLE_MANAGER',
      },
      {
        path: '/standard',
        element: <Standard />,
        isSuper: true,
        key: 'DATA_STANDARD',
      },
      {
        path: '/dict-knowledge-audit',
        element: <KnowledgeAudit />,
        // auth: true,
        // key: 'DICT_AUDIT',
      },
      {
        path: '/dict-knowledge-view',
        element: <KnowledgeView />,
        // auth: true,
        // key: 'DICT_AUDIT',
      },
    ],
  },
]

const publicRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/agreement',
    element: <Agreement />,
  },
  {
    path: '/privacyPolicy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/quote',
    element: <DictionaryQuote />,
  },
  { path: '*', element: <Exception404 /> },
]

const routesConfig = {
  privateRoutes,
  publicRoutes,
}

export default routesConfig
